module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.ajustarData(index)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.qtdSetup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.horasOciosas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.horasoperando))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.horasFuncaoString))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.horasTrabalho))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mediaSetup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.prodCaixaTop)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.prodCaixaTD)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.prodCaixaSetup)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.percentualOperando)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.percentualFuncao)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(100 - Math.round(data.percentualOperando) - Math.round(data.percentualFuncao)) + "%")])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.qtdSetup))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.total))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.horasOciosas))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.horasoperando))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.horasFuncaoString))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.horasTrabalho))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.relatorios.tabelaTotalDesempenho.mediaSetup))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(Math.round(_vm.relatorios.tabelaTotalDesempenho.prodCaixaTop)))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(Math.round(_vm.relatorios.tabelaTotalDesempenho.prodCaixaTD)))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(Math.round(_vm.relatorios.tabelaTotalDesempenho.prodCaixaSetup)))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(Math.round(_vm.relatorios.tabelaTotalDesempenho.percentualOperando)) + "%")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(Math.round(_vm.relatorios.tabelaTotalDesempenho.percentualFuncao)) + "%")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(100 - Math.round(_vm.relatorios.tabelaTotalDesempenho.percentualOperando) - Math.round(_vm.relatorios.tabelaTotalDesempenho.percentualFuncao)) + "%")])])])])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Desempenho")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Num Setups")]), _vm._v(" "), _c('th', [_vm._v("Total Produzido")]), _vm._v(" "), _c('th', [_vm._v("Tempo Ocioso")]), _vm._v(" "), _c('th', [_vm._v("Tempo Produzindo")]), _vm._v(" "), _c('th', [_vm._v("Tempo Setup")]), _vm._v(" "), _c('th', [_vm._v("Turno")]), _vm._v(" "), _c('th', [_vm._v("Tempo Médio Setup")]), _vm._v(" "), _c('th', [_vm._v("Prod. Caixa/Top")]), _vm._v(" "), _c('th', [_vm._v("Prod. Caixa/T.D")]), _vm._v(" "), _c('th', [_vm._v("Prod. Caixa/Setup")]), _vm._v(" "), _c('th', [_vm._v("Perc. Operando")]), _vm._v(" "), _c('th', [_vm._v("Perc. Setup")]), _vm._v(" "), _c('th', [_vm._v("Perc. Ocioso")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e9e160"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RelatoriosProducaoPedidosTempo.vue
// module id = 637
// module chunks = 1